import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS Webserver (Plesk)
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          Unser Webhosting mit Plesk bietet Ihnen eine professionelle und benutzerfreundliche
          Lösung für Ihre Webprojekte. Mit modernster Technologie und einfacher Verwaltung ist es
          die ideale Wahl für Websites jeder Größe.
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Hauptmerkmale
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              • Plesk Control Panel für einfache Verwaltung<br />
              • Flexible Speicheroptionen von 10 GB bis 250 GB<br />
              • Skalierbare Domain-Verwaltung (1-50 Domains)<br />
              • SSL-Zertifikate inklusive<br />
              • PHP, MySQL und weitere Technologien verfügbar<br />
              • Tägliche Backups<br />
              • 99,9% Verfügbarkeit
            </SoftTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Vorteile
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              • Einfache Verwaltung durch benutzerfreundliches Interface<br />
              • Hohe Performance durch optimierte Server-Infrastruktur<br />
              • Flexibel erweiterbar nach Ihren Bedürfnissen<br />
              • Deutschsprachiger Support<br />
              • Gehostet in deutschen Rechenzentren<br />
              • DSGVO-konform
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox mt={4} display="flex" justifyContent="center">
        <Button variant="contained" color="info" onClick={onNext}>
          Weiter zur Konfiguration
        </Button>
      </SoftBox>
    </SoftBox>
  );
}

// PropTypes
About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;